<template>
    <van-collapse>
        <van-row style="margin-left: 10px">
            <van-col span="4" v-if="!read">
                <form style="margin: 10px 0" ref="upload" v-if="showUpload">
                    <input id="jdFiles" type="file" @change="upload" name="uploadFile" multiple>
                </form>
            </van-col>
        </van-row>

        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="已加载完成"
                @load="getFileList"
        >
        <van-row v-for="(item,index) in files" style="margin: 10px 0 0 10px;height: 100%">
            <van-col span="20">
                <!--<img :src="item.fileUrl" width="100" height="100" style="margin-left: 5px;" @click="showImage(index)"/>-->
                <a v-if="item.fileType == '图片'" style="text-decoration:none;color:#333;" href="javascript:void(0)"
                   @click="showImage(index)" target="_blank">{{item.fileName | omitStr}}</a>
                <a v-else style="text-decoration:none;color:#333;" :href="item.fileUrl" target="_blank">{{item.fileName}}</a>
            </van-col>
            <van-col span="4" style="text-align: center" v-if="!read">
                <van-icon name="delete" size="22px" @click="deleteFile(item)"/>
            </van-col>
        </van-row>
        </van-list>
    </van-collapse>
</template>

<script>
    import { getFiles, delFile, uploads} from '@/api/loanInfo'
    import { eventBus } from '../../../../vue/utils/eventBus'
    import { mapGetters } from 'vuex'
    import { ImagePreview } from 'vant'

    export default {
        name: 'attachment',
        props: {
            applyId: {
                type: String,
                default: ''
            },
            groupCode: {
                type: Number,
                default: ''
            }
        },
        computed: mapGetters([
            'auditStatus',
            'userId',
        ]),
        data() {
            return {
                showUpload: true,
                loading: false,
                finished: false,
                read: true,
                images: [],
                files: []
            }
        },
        mounted() {
            let self = this

            //根据当前流程节点判断获取附件
            this.initData()

            setTimeout(function () {
                //console.log('尽职调查防止刷新—>' + self.auditStatus)
                 //尽职调查
                if (self.auditStatus == '1' && self.groupCode == '37') {
                    self.read = false
                }else if (self.auditStatus == '3' && self.groupCode == '70') {
                    //初审附件
                    self.read = false
                }else if (self.auditStatus == '7' && self.groupCode == '67') {
                    //合同文书
                    self.read = false
                }
            },600)
        },
        methods: {
            initData() {
                this.images = []
                //this.getFileList()
            },
            getFileList() {
                let self = this
                let params = {
                    applyId: this.applyId,
                    customer: this.userId,
                    groupCode: this.groupCode
                }
                getFiles(params).then(res => {
                    if (res.success) {
                        let pics = []
                        let documents = []
                        self.images = []
                        self.finished = true
                        self.loading = false
                        res.pageObj.result.forEach(item => {
                            if (item.fileType == '图片') {
                                self.images.push(item.fileUrl)
                                pics.push(item)
                            } else {
                                item.fileUrl = this.baseUrl + '/file/downloadFile?fileId=' + item.fileId + "&fileUri=" + item.fileUri
                                documents.push(item)
                            }
                        })
                        //合并文件（排序图片和文件）
                        self.files = pics.concat(documents);
                    }
                })
            },
            upload() {
                let self = this
                self.loadings()
                let formData = new FormData(this.$refs.upload)
                formData.append('applyId', this.applyId)
                formData.append('groupCode', this.groupCode)
                formData.append('customerId', this.userId)
                uploads(formData).then(res => {
                    self.closeLoadings()
                    if (res.success) {
                        self.$toast('操作完成，上传成功：'+ res.count + "，失败：" + res.failure)
                        self.resetInputFile()
                        self.getFileList()
                    }
                }).catch(err => {
                    self.closeLoadings()
                })
            },
            deleteFile(file) {
                this.$dialog.confirm({
                    title: '删除',
                    message: '是否确认删除当前文件?'
                }).then(() => {
                    let data = {
                        customerFileId: file.customerFileId
                    }
                    delFile(data).then(res => {
                        this.$toast(res.msg)
                        this.getFileList()
                    })
                }).catch(() => {
                    // on cancel
                })
            },
            showImage(position) {
                const instance = ImagePreview({
                    images: this.images,
                    lazyLoad: true,
                    startPosition: typeof position === 'number' ? position : 0
                })
            },
            loadings() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '正在上传...'
                })
            },
            closeLoadings() {
                this.$toast.clear()
            },
            resetInputFile() {
                let file = document.getElementById('jdFiles')
                file.value = ''
            }
        }
    }
</script>

<style scoped>
    .htmlContent {
        overflow: auto;
    }
</style>
